<template>
  <div
    class="item"
    @click="bindClickPlanItem"
    v-clickBuried
    :data-click-buried="[
      'CLICK_JIHUALIEBIAO_XTJIHUA_' + data.id,
      'CLICK_JIHUALIEBIAO_XTJIHUA'
    ]"
    v-buried
    :data-buried="'BG_JIHUALIEBIAO_XTJIHUA_' + data.id"
  >
    <div class="item-top">
      <div class="item-image-wrapper">
        <div
          class="item-flag-wrapper"
          v-if="data.show_tag && data.show_tag.tag_name"
        >
          <div class="item-flag"
            >{{ data.show_tag && data.show_tag.tag_name }}推荐</div
          >
        </div>
        <img class="item-image" :src="data.list_cover_image" alt="" />
      </div>
      <div class="item-right">
        <div class="item-title">{{ data.title }}</div>
        <div class="item-info"
          ><span>由</span
          ><img
            class="item-avatar"
            :src="data.experts.head_portrait"
            alt=""
          /><span>{{ data.experts.name }}</span
          >编写</div
        >
        <div class="tag-list">
          <div
            class="tag-item"
            v-for="(item, index) in data.efficacies"
            :key="index"
            >{{ item }}</div
          >
        </div>
        <div class="item-t-bottom">
          <div class="item-b-left">
            <div class="buji-list" v-if="data.product_images.length">
              <img
                class="buji-item"
                v-for="(item, index) in data.product_images"
                :key="index"
                v-show="index < 4"
                :style="{ transform: 'translateX(' + index * -7 + 'px)' }"
                :src="item"
                alt=""
              />
              <div
                class="item-more iconfont icon-gengduo1"
                v-if="data.product_images.length > 4"
                :style="{
                  transform:
                    'translateX(' +
                    (data.product_images.length > 4
                      ? 4
                      : data.product_images.length) *
                      -7 +
                    'px)'
                }"
              >
              </div>
              <div
                class="item-num"
                :style="{
                  transform:
                    'translateX(' +
                    ((data.product_images.length > 4
                      ? 4
                      : data.product_images.length - 1) *
                      -7 +
                      12) +
                    'px)'
                }"
              >
                共{{ data.product_images.length }}种补剂</div
              >
            </div>
            <div class="item-use">{{ data.eat_count }}人正在使用</div>
          </div>
          <div class="item-btn" :class="{ 'item-btn-active': data.is_used }">{{
            data.is_used ? '正在使用' : '查看计划'
          }}</div>
        </div>
      </div>
    </div>
    <div class="item-bottom" v-if="data.recommend_tips">
      <img
        class="item-icon"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/76965ddb1e310c7a8359200243e5ccad.png"
        alt=""
      />
      <div class="item-b-text">{{ data.recommend_tips }}</div>
    </div>
    <!--  <img class="item-image" :src="data.list_cover_image" alt="">
        <div class="item-use" v-if="data.is_used">正在使用</div>
        <div class="item-num">{{ data.eat_count }}人正在使用</div>
        <div class="item-content">
            <div class="item-top">
                <div class="item-title">{{ data.title }}</div>
                <div class="item-desc">{{ data.introduction }}</div>
            </div>
            <div class="item-bottom">
                <div class="bj-list">
                    <div class="bj-item" v-for="(item, index) in data.product_list" :key="index">
                        <img class="bj-brand" :src="item.brand_img" alt="">
                        <img class="bj-image" :src="item.image" alt="">
                        <div class="bj-right">
                            <div class="bj-name">{{ item.p_title }}</div>
                            <div class="bj-bottom">
                                <div class="bj-desc">1日{{ item.daily_times }}次·{{ item.every_times_num }}{{item.min_unit_txt}}/次 ·
                                    {{ item.take_suggested_time_txt }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClick() {},
    bindClickImage(item) {
      this.$router.push({
        path: '/nutrition-clock/tonic-detail',
        query: {
          id: item.id
        }
      })
    },
    bindClickPlanItem() {
      if (this.data.id) {
        this.$router.push({
          path: '/nutrition-clock/plan-detail',
          query: {
            id: this.data.id,
            isUsed: this.data.is_used,
            planType: 2
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.item {
  background: #ffffff;
  border-radius: 8px;
  padding: 10px;

  .item-top {
    display: flex;
    align-items: center;

    .item-image-wrapper {
      position: relative;

      .item-flag-wrapper {
        position: absolute;
        left: -4px;
        top: -5px;

        .item-flag {
          padding: 0px 2px;
          max-width: 90px;
          box-sizing: border-box;
          height: 14px;
          line-height: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          background: #03d4e6;
          border-radius: 4px 2px 4px 0px;
          font-weight: bold;
          font-size: 8px;
          color: #ffffff;
        }
      }
      .item-flag-wrapper::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0px;
        width: 0;
        height: 0;
        border-bottom: 3px solid #01b3c3;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        transform: rotate(45deg);
        transform-origin: center;
      }
    }

    .item-image {
      width: 100px;
      height: 100px;
      border-radius: 6px;
      overflow: hidden;
      object-fit: cover;
      margin-right: 10px;
    }

    .item-right {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;

      .item-title {
        font-weight: bold;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.8);
        line-height: 20px;
        margin-bottom: 4px;
      }

      .item-info {
        margin-bottom: 4px;
        font-size: 10px;
        color: rgba(0, 0, 0, 0.5);
        line-height: 14px;
        display: flex;
        align-items: center;

        .item-avatar {
          margin: 0px 3px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          overflow: hidden;
          object-fit: cover;
        }
      }

      .tag-list {
        display: flex;
        flex-wrap: wrap;

        .tag-item {
          padding: 0px 3px;
          white-space: nowrap;
          height: 16px;
          background: #fef8e1;
          border-radius: 2px;
          font-size: 10px;
          color: #fe8b1a;
          line-height: 16px;
          margin-right: 6px;
          margin-bottom: 5px;
        }
      }

      .item-t-bottom {
        display: flex;
        align-items: flex-end;

        .item-b-left {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          display: flex;
          align-items: flex-start;
          flex-direction: column;

          .buji-list {
            display: inline-flex;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: 6px;

            .buji-item {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              object-fit: cover;
              overflow: hidden;
              border: 1px solid #ffffff;
            }
          }

          .item-use {
            font-size: 10px;
            color: rgba(0, 0, 0, 0.5);
            line-height: 14px;
          }

          .item-more {
            width: 20px;
            height: 20px;
            box-sizing: border-box;
            border-radius: 50%;
            overflow: hidden;
            background: #f3f3f3;
            border: 1px solid #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
          }

          .item-num {
            white-space: nowrap;
            font-size: 10px;
            color: rgba(0, 0, 0, 0.5);
            line-height: 14px;
          }
        }

        .item-btn {
          text-align: center;
          width: 70px;
          height: 26px;
          line-height: 26px;
          background: #03d4e6;
          border-radius: 14px;
          font-weight: bold;
          font-size: 12px;
          color: #ffffff;
        }

        .item-btn-active {
          background: rgba(3, 212, 230, 0.1);
          color: #00cddf;
        }
      }
    }
  }

  .item-bottom {
    background: #fff9ef;
    border-radius: 4px;
    padding: 4px 6px;
    display: flex;
    align-items: center;
    margin-top: 10px;

    .item-icon {
      width: 10px;
      height: 10px;
      object-fit: contain;
      margin-right: 4px;
    }

    .item-b-text {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-weight: bold;
      font-size: 10px;
      color: #ab8c57;
      line-height: 14px;
    }
  }
}
</style>
